import { render } from "./VTabs.vue?vue&type=template&id=951349c8"
import script from "./VTabs.vue?vue&type=script&lang=js"
export * from "./VTabs.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__